import { render, staticRenderFns } from "./RechargeForm.vue?vue&type=template&id=95cd1540&scoped=true&"
import script from "./RechargeForm.vue?vue&type=script&lang=js&"
export * from "./RechargeForm.vue?vue&type=script&lang=js&"
import style0 from "./RechargeForm.vue?vue&type=style&index=0&id=95cd1540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd1540",
  null
  
)

export default component.exports